var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"video-viewer"}},[(_vm.getSrc)?_c('vue-plyr',{attrs:{"options":_vm.options}},[_c('video',{attrs:{"controls":"","playsinline":""}},[_c('source',{attrs:{"src":_vm.getSrc,"type":"video/mp4"}})])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }